export const HEADING_FONT = `'Pinyon Script', cursive;`;
export const HEADING_ALTERNATIVE = `'Pinyon Script', cursive;`;
export const BODY_FONT = `'Cormorant Garamond', serif;`;
export const BODY_ALTERNATIVE = `'Inconsolata', monospace;`;